import { render, staticRenderFns } from "./setting-create-user-sidebar.vue?vue&type=template&id=384234bf&scoped=true&"
import script from "./setting-create-user-sidebar.vue?vue&type=script&lang=js&"
export * from "./setting-create-user-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./setting-create-user-sidebar.vue?vue&type=style&index=0&id=384234bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384234bf",
  null
  
)

export default component.exports